// extracted by mini-css-extract-plugin
export default {"button":"PurpleButton_button__mCOvg","title":"PurpleButton_title__JiHeB"};